// @ngInject
function stateConfig($stateProvider) {
    var view = {
        'wideColumnView@sales': {
            templateUrl: 'main/sales/salescomparison/salescomparison.tpl.html',
            controller: 'SalesComparisonController as vm'
        }
    };

    // Relative: /sales/reports/week/current, /sales/reports/month/previous
    $stateProvider.state('sales.reports', {
        url: '/reports/{period}/{selector}?{receiptMode}',
        views: view
    });

    // Permalink: /sales/reports/year/2026/week/23
    $stateProvider.state('sales.reportsYear', {
        url: '/reports/year/{year}/{period}/{number}?{receiptMode}',
        views: view
    });
}

// @ngInject
function SalesComparisonController() {
    var vm = this;
}

angular
    .module('sales.salescomparison', [])
    .config(stateConfig)
    .controller('SalesComparisonController', SalesComparisonController);
